export default "__VITE_ASSET__DB0qcCOs__"